import DiftBlock from 'blocks/Dift'

export function Dift() {
  return <DiftBlock />
}
